<template>
  <div>
    <ul class="filter-wrapper" v-if="typeRadio">
      <template>
        <li v-for="item in list" :key="item.id" :title="item.nom">
          <b-form-radio
            class="radio-format"
            v-model="selected"
            :name="type + '-radios'"
            :value="item.id"
            @change="handleChange(item.id, !!item.template)"
            >{{ item.nom }}
            <!-- font-awesome-icon
              class=""
              v-if="selected === item.id"
              :icon="['fas', 'angle-right']"
          / --></b-form-radio
          >
        </li>
      </template>
    </ul>
    <b-form-group v-if="type === 'espace'" class="espace-wrapper">
      <div class="wrapper-dupliquer">
        <b-button
          variant="primary"
          @click="handleCopyTableau"
          :disabled="disabledAddTableau()"
          title="Copier le tableau avec les mises en formes"
        >
          <b-spinner v-if="!this.isCopied()" small type="grow"></b-spinner>
          Dupliquer en entier</b-button
        >

        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          aria-describedby="espaces"
          aria-controls="espaces"
          @change="toggleAll"
          >Tous les espaces</b-form-checkbox
        >
      </div>

      <template>
        <b-form-checkbox-group
          v-model="checkBoxSelected"
          :id="type + '-checkbox'"
          :name="type + '-checkbox'"
          :options="listElement"
          stacked
        ></b-form-checkbox-group>
      </template>
    </b-form-group>
  </div>
</template>
<script>
import { events, EventBus } from '../../eventBus'
import { mapGetters } from 'vuex'
export default {
  props: {
    type: String,
    list: Array,
    typeRadio: Boolean
  },
  data () {
    return {
      selected: null,
      checkBoxSelected: [],
      allSelected: false,
      indeterminate: false
    }
  },
  mounted () {
    EventBus.$on(events.RESET_FILTER, () => {
      this.selected = null
      this.checkBoxSelected = []
    })
  },
  computed: {
    listElement () {
      return this.list.map(x => {
        return {
          text: x.nom.trim(),
          value: `${x.id.trim()}--${x.index}`
        }
      })
    }
  },
  watch: {
    checkBoxSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.list.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }

      EventBus.$emit(events.SELECT_ESPACES, newVal)
    }
  },
  methods: {
    ...mapGetters(['disabledAddTableau', 'isCopied']),
    handleChange (id, template = false) {
      EventBus.$emit(events.SELECT_PROJECT, id, this.type, template)
    },
    toggleAll (checked) {
      this.checkBoxSelected = checked ? this.listElement.map(x => x.value).flat() : []
    },
    handleCopyTableau () {
      EventBus.$emit(events.COPY_TABLEAU)
    }
  }
}
</script>
<style lang="scss">
.filter-wrapper {
  list-style: none;
  padding-left: 0;
  li {
    // box-shadow: inset 0 -1px 0 0 #f2f7fa;
    height: 25px;
    line-height: 25px;
    padding-right: 8px;
    .custom-control {
      padding-left: 0;
      color: #2b3085;
      .custom-control-input:checked {
        & ~ label {
          color: #fff;
          background-color: #2b3085;
        }
      }
    }
    label {
      font-size: 12px;
      display: block;
      padding-left: 15px;
      padding-right: 15px;
      font-weight: 500;
      width: 100%;
      cursor: pointer;
      &::after,
      &::before {
        display: none;
      }
    }
  }
  .radio-format {
    label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      svg {
        font-size: 16px;
      }
    }
  }
}
.wrapper-py5 {
  padding: 5px 0;
}

.wrapper-dupliquer {
  box-shadow: inset 0 -1px 0 0 #f2f7fa;
  padding: 10px 25px;
  margin-right: -15px;
  margin-left: -15px;
  margin-bottom: 10px;
}

.espace-wrapper {
  padding: 0px 15px;
  .custom-control {
    // box-shadow: inset 0 -1px 0 0 #f2f7fa;
    height: 25px;
    label {
      vertical-align: middle;
    }
    .custom-control-label {
      color: #2b3085;
      &:before,
      &:after {
        top: 0;
      }
    }
  }
  .btn {
    border: 1px solid #2b3085;
    color: #2b3085;
    border-radius: 0;
    background-color: #fff;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tableau/listingBlock.vue